import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { EventDateFilterComponent } from '../event-calendar/components/event.date.filter/event.date.filter.component';
import { VisitorFancyCardComponent } from './components/visitor/cards/visitor.fancy.card/visitor.fancy.card.component';
import { VisitorSideBarComponent } from './components/visitor/menu.bars/visitor.side.bar/visitor.side.bar.component';
import { VisitorTopBarComponent } from './components/visitor/menu.bars/visitor.top.bar/visitor.top.bar.component';
import { VisitorComponent } from './components/visitor/visitor.component';
import { RouterModule } from '@angular/router';
import { VisitorCalendarComponent } from './components/visitor/visitor.calendar/visitor.calendar.component';
import {
  InfiniteScrollContainerComponent
} from './components/infinite.scroll.container/infinite.scroll.container.component';
import { SharedModule } from './shared.module';
import { PoweredByComponent } from './components/powered.by/powered.by.component';
import {
  FavoriteCustomEventFilterComponent
} from '../event-calendar/components/favorite.custom.event.filter/favorite.custom.event.filter.component';
import {
  VisitorTopBarColdComponent
} from './components/visitor/menu.bars/visitor.top.bar.cold/visitor.top.bar.cold.component';
import { EventTimeComponent } from './components/visitor/event.time/event.time.component';
import {
  VisitorSquareCardComponent
} from './components/visitor/cards/visitor.square.card/visitor.square.card.component';
import {
  VisitorDefaultCardComponent
} from './components/visitor/cards/visitor.default.card/visitor.default.card.component';
import { VisitorLongCardComponent } from './components/visitor/cards/visitor.long.card/visitor.long.card.component';
import {
  VisitorModernBlockComponent
} from './components/visitor/cards/visitor.modern.block/visitor.modern.block.component';
import {
  VisitorVerticalCardComponent
} from './components/visitor/cards/visitor.vertical.card/visitor.vertical.card.component';
import { WaterFallContainerComponent } from './components/water.fall.container/water.fall.container.component';
import {
  FancyEventDetailsModalComponent
} from '../event-calendar/components/event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component';
import { UpcomingEventsComponent } from '../event-calendar/components/upcoming.events/upcoming.events.component';
import { MultiEventTimesComponent } from '../event-calendar/components/multi.event.times/multi.event.times.component';
import {
  EventDetailSideModalComponent
} from '../event-calendar/components/event.detail.side.modal/event.detail.side.modal.component';
import { InfoTicketComponent } from '../event-calendar/components/info.ticket/info.ticket.component';
import { CreateEventComponent } from '../event-calendar/components/create.event/create.event.component';
import { OneRowWidgetComponent } from './components/visitor/one.row.widget/one.row.widget.component';
import {
  AddToCalendarBtnComponent
} from '../event-calendar/components/add.to.calendar.btn/add.to.calendar.btn.component';
import {
  FavoriteCustomPlaceFilterComponent
} from '../place-calendar/components/favorite.custom.place.filter/favorite.custom.place.filter.component';
import { TimelineComponent } from '../event-calendar/components/timeline/timeline.component';
import {
  CustomDefaultPlaceCategoryFilterComponent
} from '../place-calendar/components/custom.default.place.category.filter/custom.default.place.category.filter.component';
import {
  PlaceDetailsSideModalComponent
} from '../place-calendar/components/place.details.side.modal/place.details.side.modal.component';
import {
  NestedAccordionItemComponent
} from '../place-calendar/components/custom.default.place.category.filter/nested.accordion.item/nested.accordion.item.component';
import {
  FancyPlaceDetailsModalComponent
} from '../place-calendar/components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';
import {
  OpeningHoursComponent
} from '../place-calendar/components/place.details.modal/opening.hours/opening.hours.component';
import {
  GooglePlaceReviewsComponent
} from '../place-calendar/components/google.place.reviews/google.place.reviews.component';
import { DineIconsComponent } from '../place-calendar/components/place.details.modal/dine.icons/dine.icons.component';
import { VisitorPlaceMapComponent } from '../place-calendar/components/visitor.place.map/visitor.place.map.component';
import { CreatePlaceComponent } from '../place-calendar/components/create.place/create.place.component';
import {
  EditPlaceCategoryModalComponent
} from '../place-calendar/components/edit.place.category.modal/edit.place.category.modal.component';
import {
  PlaceCategorySelectorComponent
} from '../place-calendar/components/edit.place.category.modal/place.category.selector/place.category.selector.component';
import { NearbyPlacesComponent } from './components/nearby.places/nearby.places.component';
import {
  EventLocationFilterComponent
} from '../event-calendar/components/event.location.filter/event.location.filter.component';
import {
  PlaceLocationFilterComponent
} from '../place-calendar/components/place.location.filter/place.location.filter.component';
import {
  AiBuddyPlaceListingComponent
} from '../place-calendar/components/ai.buddy.place.listing/ai.buddy.place.listing.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SecureHtmlPipe } from '../../common/pipes/secure.html.pipe';

const COMMON_COMPONENTS = [
  VisitorComponent,
  VisitorCalendarComponent,
  VisitorTopBarComponent,
  VisitorSideBarComponent,
  InfiniteScrollContainerComponent,
  VisitorTopBarColdComponent,

  PoweredByComponent,
  EventDateFilterComponent,
  EventLocationFilterComponent,
  FavoriteCustomEventFilterComponent,
  EventTimeComponent,

  VisitorFancyCardComponent,
  VisitorSquareCardComponent,
  VisitorDefaultCardComponent,
  VisitorLongCardComponent,
  VisitorModernBlockComponent,
  VisitorVerticalCardComponent,
  WaterFallContainerComponent,

  UpcomingEventsComponent,
  FancyEventDetailsModalComponent,
  FancyPlaceDetailsModalComponent,
  MultiEventTimesComponent,
  EventDetailSideModalComponent,
  PlaceDetailsSideModalComponent,
  InfoTicketComponent,
  CreateEventComponent,
  OneRowWidgetComponent,
  AddToCalendarBtnComponent,
  TimelineComponent,
  OpeningHoursComponent,
  GooglePlaceReviewsComponent,
  DineIconsComponent,
  VisitorPlaceMapComponent,
  CreatePlaceComponent,
  EditPlaceCategoryModalComponent,
  PlaceCategorySelectorComponent,
  PlaceLocationFilterComponent,
  AiBuddyPlaceListingComponent,

  FavoriteCustomPlaceFilterComponent,
  CustomDefaultPlaceCategoryFilterComponent,
  NestedAccordionItemComponent,
  NearbyPlacesComponent,
];

const THIRD_PARTY_MODULES = [];

@NgModule({
  declarations: [...COMMON_COMPONENTS],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    ...THIRD_PARTY_MODULES,
    MatIconModule,
    MatIconModule,
    MatMenuModule,
    SecureHtmlPipe,
  ],
  exports: [...COMMON_COMPONENTS, ...THIRD_PARTY_MODULES],
})
export class CalendarSharedModule {
}
